// eslint-disable-next-line @typescript-eslint/no-empty-function
export const createHashDataset = (dataset: any[], callback: any | undefined = () => {}) =>
  dataset.reduce((tree: any, data: any) => {
    const { _id: id } = data;

    const values = callback(data);

    // eslint-disable-next-line no-param-reassign
    tree[id] = { id, ...values };

    return tree;
  }, {});
